"use client"
import { ampli } from "@/ampli"
import { Button } from "@/elements"
import Link from "next/link"

export const JoinNovaButton = () => {
  return (
    <Link href="/sign-up">
      <Button size="small">Join NOVA</Button>
    </Link>
  )
}
